import { importAllTranslations } from '../utils.js';

// Import automatique de tous les fichiers .js dans ce dossier
export default importAllTranslations(
  require.context('./', false, /^(?!.*index\.js$).*\.js$/)
);
